import type { ParseKeys } from 'i18next';

export const DemoBadgeVariants = ['demo', 'not-ported', 'no-feature'] as const;
export type DemoBadgeVariant = (typeof DemoBadgeVariants)[number];

/**
 * `not-ported` marks a figure that exists elsewhere and only needs exposing here,
 * so a real number is on its way. `no-feature` marks one that has to be designed
 * before it can be built. Keeping them apart stops the two being read, and
 * estimated, as if they cost the same.
 *
 * Holds dictionary keys, not text: `t()` at module level would run once at import and never
 * follow the language. `DemoBadge` translates at render, and a test resolves the same keys.
 */
export const demoBadgeKey = {
  demo: 'demoBadge.demo',
  'not-ported': 'demoBadge.notPorted',
  'no-feature': 'demoBadge.noFeature',
} as const satisfies Record<DemoBadgeVariant, ParseKeys<'metrics'>>;
